import React, { Component } from 'react';
//import Gallery from 'react-grid-gallery';
import './App.css';
import Selection from './Selection.js'
import AppEntry from './AppEntry.js'


//className="App-logo" for rotating image (svg)
/* renders a full functional gallery !
 USES the import : import Gallery from 'react-grid-gallery';
<Gallery images={IMAGES}/>
const IMAGES =
[{
        src: "http:www.lingolongo.de/img/icon512free.png",
        thumbnail: "http:www.lingolongo.de/img/icon512free.png",
        thumbnailWidth: 512,
        thumbnailHeight: 128,
        isSelected: true,
        caption: "Face the world"
},
{
        src: "http:www.lingolongo.de/img/icon512free.png",
        thumbnail: "http:www.lingolongo.de/img/icon512free.png",
        thumbnailWidth: 512,
        thumbnailHeight: 128,
        isSelected: true,
        caption: "Face the world PRO"
},
{
        src: "http:www.lingolongo.de/img/iconpro.png",
        thumbnail: "http:www.lingolongo.de/img/iconpro.png",
        thumbnailWidth: 512,
        thumbnailHeight: 128,
        isSelected: true,
        caption: "Tiny Toon and world cam"
}]
*/

class App extends Component {

	constructor()
	{
		super();
		
		
	}
  render() {
	
	var ftw = new AppEntry("Face the world", "icon512free.png", "notmyface");
	var ftwp = new AppEntry("Face the world pro", "icon512pro.png", "notmyface.pro");
	var ttc = new AppEntry("Tiny World Cam", "iconpro.png", "tinytooncampro");
	var icc = new AppEntry("Ice Cube Challenge", "Logo512black.png", "icecube");
	let entries = [ ftw, ftwp, ttc, icc ];
    return (
      <div className="App">
        <div className="App-header">
          <img src="img/lingolongo.png" className="App-logo-still" alt="logo" />
          <h2>Welcome to lingolongo.de</h2>
		  <p>Follow the links below to find my latest Android apps in the playstore...</p>
      
        </div>
		<div>
    <p>Or find a nice online matchup (memory) game against artificial intelligence <a href="/memopry/index.html">HERE</a></p>
			<Selection apps={entries}/>
		</div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js